import React, {Fragment, useState} from 'react';
import PropTypes from 'prop-types';
import {
    Table as DefectManagementTable,
    Thead,
    Tbody,
    Tr,
    Th
} from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import Row from './Row';
import ModalCustom from "../design/shared/modal";
import DefectSummary from "./DefectSummary/DefectSummary";
import {customStyles} from "./css";
import {useLocalizedStringsContext} from "../context/LocalizedStringsContext";

const Table = ({setFetchData, header = {}, data = []}) => {

    const localizedString = useLocalizedStringsContext();
    const {DEFECT_MANAGEMENT: {VIEW_DEFECT = ''} = {}} = localizedString;

    const [selectedDefect, setSelectedDefect] = useState({});
    const [openModal, setOpenModal] = useState(false);


    return (
        <Fragment>
            <DefectManagementTable>
                <Thead style={{background: '#e2e2e2'}}>
                    <Tr>
                        {Object.keys(header).map(key => (
                            <Th key={key}>{header[key]}</Th>
                        ))}
                    </Tr>
                </Thead>
                <Tbody>
                    {data &&
                        data.map((defect, index) => (
                            <Row key={defect.id} index={index} defect={defect} selectedDefect={setSelectedDefect}
                                 openModal={setOpenModal}/>
                        ))}
                </Tbody>
            </DefectManagementTable>
            <ModalCustom open={openModal} setOpen={() => {
                setOpenModal(false);
                setSelectedDefect({});
            }} header={VIEW_DEFECT} customStyles={customStyles}>
                <DefectSummary setFetchData={setFetchData} openModal={setOpenModal} defect={selectedDefect}/>
            </ModalCustom>
        </Fragment>
    );
};

Table.propTypes = {
    data: PropTypes.objectOf(PropTypes.array).isRequired,
    header: PropTypes.objectOf(PropTypes.any).isRequired,
    setFetchData: PropTypes.func.isRequired
};

export default Table;
